export default __webpack_public_path__ + "static/media/Calender.256850a2.svg";